<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Transaksi Kas Keluar</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="input.filterFromDate" name="filterFromDate"
                            id="filterInput"
                            type="date"
                        ></b-form-input>
                        <span class="mr-2 d-flex align-items-center">to</span>
                        <b-form-input class="mr-2" 
                            v-model="input.filterToDate" name="filterToDate"
                            type="date"
                        ></b-form-input>
                        
                        <b-form-select class="mr-2" v-model="input.filterStatus" name="statuskasKeluar" :options="statusOption" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih status --</b-form-select-option>
                            </template>
                        </b-form-select>

                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="kasKeluarInputBtn" @click="inputKasKeluar">Input Kas Keluar</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy" 
                :items="kasKeluar" 
                :fields="fields"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data kas keluar.
                </template>
                <template v-slot:cell(nominal)="row">
                    <div class="text-right no-wrap" v-if="row.item.nominal !== null">Rp. {{$helper.addThousandSeparator(row.item.nominal)}} </div>
                    <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.nominal)}} </div>
                </template>
                <template v-slot:cell(diajukanOleh)="row">
                    <p class="mb-0">{{row.item.diajukanOleh}}</p>
                    <p class="mb-0 text-muted">{{row.item.cabang}}</p>
                </template>
                <template v-slot:cell(diajukanPada)="row">
                    <div>{{$helper.changeDateFormat(row.item.diajukanPada)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.diajukanPada)}}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="warning" v-if="row.item.status == 'PENDING'">PENDING</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'DITERIMA'">DITERIMA</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'DITOLAK'">DITOLAK</b-badge>
                    <b-badge variant="dark" v-else-if="row.item.status == 'BATAL'">BATAL</b-badge>
                    <b-badge v-else>{{ row.item.status }}</b-badge>   
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap" v-if="row.item.status == 'PENDING' " >
                        <b-button class="mr-2 table-button cancel" size="sm" v-b-tooltip.hover title="Batal" name="batalBtn" @click="openModalKeteranganCancel(row.item.id)">
                            <i class="fa fa-close"></i>
                        </b-button>
                        <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="viewBtn" @click="viewDetailKasKeluar(row.item.id)">
                            <i class="fa fa-info"></i>
                        </b-button>
                    </div>
                    <div class="no-wrap" v-else>
                        <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="viewBtn" @click="viewDetailKasKeluar(row.item.id)">
                            <i class="fa fa-info"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-detail-kasKeluar" title="Detail Kas Keluar" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title">DATA KAS KELUAR</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Tanggal Pengajuan</b-col>
                    <b-col v-if="detailKasKeluar.diajukanPada != null">{{$helper.changeDateFormat(detailKasKeluar.diajukanPada)}} {{$helper.changeDateFormatGetHour(detailKasKeluar.diajukanPada)}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Diajukan Oleh</b-col>
                    <b-col v-if="detailKasKeluar.diajukanOleh != null">{{ detailKasKeluar.diajukanOleh }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Nominal</b-col>
                    <b-col v-if="detailKasKeluar.nominal != null">Rp. {{ $helper.addThousandSeparator(detailKasKeluar.nominal) }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Keterangan Pengajuan</b-col>
                    <b-col v-if="detailKasKeluar.keterangan != null">{{ detailKasKeluar.keterangan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Status</b-col>
                    <b-col v-if="detailKasKeluar.status != null">{{ detailKasKeluar.status }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Tanggal Proses</b-col>
                    <b-col v-if="detail.diprosesPada != null">{{$helper.changeDateFormat(detail.diprosesPada)}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Diproses Oleh</b-col>
                    <b-col v-if="detail.diprosesOleh != null">{{ detail.diprosesOleh }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Keterangan Diproses</b-col>
                    <b-col v-if="detail.keteranganProses != null">{{ detail.keteranganProses }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-cancel-kasKeluar" size="md" title="Cancel Kas Keluar" no-close-on-backdrop>
            <b-form id="cancelKasKeluarForm" @submit.prevent="openConfirmCancelKasKeluar()">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Keterangan" class="mb-0">
                        <b-form-textarea 
                            v-model="input.keteranganCancel" name="keteranganCancel"
                            rows="3"
                            max-rows="6"
                            required
                        ></b-form-textarea>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeCancelBtn" @click="cancel()">
                    Tutup
                </b-button>
                <b-button variant="pgiBtn" name="cancelKasKeluarSubmitBtn" type="submit" form="cancelKasKeluarForm">
                    Kirim
                </b-button>
            </template>
        </b-modal>
        <ModalConfirm id="modal-confirm-cancel" title="Confirm Batalkan Kas Keluar" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk membatalkan kas keluar ini?" @submit="onCancelKasKeluar" />
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENDING</h6>
                <p class="smallText mb-0">Permohonan kas keluar masih menunggu untuk diproses oleh HO.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DISETUJUI</h6>
                <p class="smallText mb-0">Permohonan kas keluar disetujui oleh HO. Kas cabang sudah disesuaikan sesuai dengan nominal kas keluar.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITOLAK</h6>
                <p class="smallText mb-0">Permohonan kas keluar ditolak oleh HO. Kas cabang tidak berubah.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">BATAL</h6>
                <p class="smallText mb-0">Permohonan kas keluar dibatalkan oleh pengaju.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'transaksi-kas-keluar',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            role: null,
            activeId: null,
            input:{
                show: 10,
                filterFromDate: null,
                filterToDate: null,
                filterStatus: null,
                keteranganCancel: ''
            },
            fields: [
                { key: "diajukanPada", label: "Tanggal" },
                { key: "diajukanOleh", label: "Diajukan oleh" },
                { key: "nominal", label: "Nominal" },
                { key: "keterangan", label: "Keterangan" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusOption: [
                { id: 0, name: 'Pending'},
                { id: 1, name: 'Disetujui'},
                { id: 2, name: 'Ditolak'},
                { id: 3, name: 'Batal'}
            ],
            kasKeluar: [],
            detailKasKeluar: {},
            detail: {
                keteranganProses: null,
                diprosesOleh: null,
                diprosesPada: null
            },
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {
        
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            
            this.role = localStorage.role

            let getKasKeluar = this.$axios.get("cabang/kas/keluar/"+this.query).then(response => {
                this.kasKeluar = response.data.data
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getKasKeluar]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Ambil Data Kas Keluar -----------------

        getKasKeluar(){
            this.toggleBusy()
            this.kasKeluar = []

            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) this.query = this.query + "&filterStartDate=" + this.input.filterFromDate
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)) this.query = this.query + "&filterEndDate=" + this.input.filterToDate
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            
            this.$axios.get("cabang/kas/keluar/"+this.query).then(response => {
                this.kasKeluar = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getKasKeluar()
        },

        onPageChange(){
            if (this.loading == false) {
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getKasKeluar()
            }
        },

        onReset(){
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getKasKeluar()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true

            if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.getKasKeluar()
            }
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        inputKasKeluar(){
            this.$router.push({path: `${this.$route.path}/input`});
        },

        openModalKeteranganCancel(id){
            this.activeId = id
       
            this.$bvModal.show("modal-cancel-kasKeluar")
        },

        openConfirmCancelKasKeluar(){
            this.$bvModal.show("modal-confirm-cancel")
        },

        onCancelKasKeluar(){
       
            let payload = new FormData()
            
            //----------------- Append Data -----------------

            payload.append("id", this.activeId)
            payload.append("keterangan", this.input.keteranganCancel)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            this.$axios.post("cabang/kas/keluar/cancel/", payload).then(() => {
                this.getKasKeluar()
                this.$bvModal.hide("modal-cancel-kasKeluar")
                this.$bvModal.hide("modal-confirm-cancel")
                this.$helper.toastSucc(this, "Kas keluar berhasil dibatalkan!")

            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        viewDetailKasKeluar(id){
            let idx = this.kasKeluar.findIndex(item => item.id == id);
            this.detailKasKeluar = this.kasKeluar[idx]
            this.$axios.get(`cabang/kas/keluar/${id}`).then(response => {
                
                this.$bvModal.show("modal-detail-kasKeluar")
         
                this.detail.keteranganProses = response.data.keteranganProses
                this.detail.diprosesOleh = response.data.diprosesOleh
                this.detail.diprosesPada = response.data.diprosesPada

            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        },

        getSingleDetailKasKeluar(id){
            this.$axios.get(`cabang/kas/keluar/${id}`).then(response => {
                
                this.$bvModal.show("modal-detail-kasKeluar")

                this.detailKasKeluar.keteranganProses = response.data.keteranganProses
                this.detailKasKeluar.diprosesOleh = response.data.diprosesOleh
                this.detailKasKeluar.diprosesPada = response.data.diprosesPada
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
        }

    },
    created(){
        this.init()
    }
}
</script>
